var _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5713_31812)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V4H22L18 0Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#F14848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75746 18V12.1818H6.93928C7.38625 12.1818 7.76125 12.2652 8.06428 12.4318C8.3692 12.5985 8.59931 12.8277 8.75462 13.1193C8.91181 13.4091 8.99041 13.7386 8.99041 14.108C8.99041 14.4811 8.91181 14.8125 8.75462 15.1023C8.59742 15.392 8.36541 15.6203 8.05859 15.7869C7.75178 15.9517 7.37393 16.0341 6.92507 16.0341H5.47905V15.1676H6.78303C7.04439 15.1676 7.2584 15.1222 7.42507 15.0312C7.59174 14.9403 7.71484 14.8153 7.79439 14.6562C7.87583 14.4972 7.91655 14.3144 7.91655 14.108C7.91655 13.9015 7.87583 13.7197 7.79439 13.5625C7.71484 13.4053 7.59079 13.2831 7.42223 13.196C7.25556 13.107 7.0406 13.0625 6.77734 13.0625H5.81143V18H4.75746ZM11.8775 18H9.90589V12.1818H11.9173C12.4949 12.1818 12.9911 12.2983 13.4059 12.5312C13.8226 12.7623 14.1426 13.0947 14.3661 13.5284C14.5896 13.9621 14.7013 14.4811 14.7013 15.0852C14.7013 15.6913 14.5887 16.2121 14.3633 16.6477C14.1398 17.0833 13.8169 17.4176 13.3945 17.6506C12.9741 17.8835 12.4684 18 11.8775 18ZM10.9599 17.0881H11.8263C12.2317 17.0881 12.5697 17.0142 12.8406 16.8665C13.1114 16.7169 13.315 16.4943 13.4513 16.1989C13.5877 15.9015 13.6559 15.5303 13.6559 15.0852C13.6559 14.6402 13.5877 14.2708 13.4513 13.9773C13.315 13.6818 13.1133 13.4612 12.8462 13.3153C12.5811 13.1676 12.2515 13.0938 11.8576 13.0938H10.9599V17.0881ZM15.7028 18V12.1818H19.43V13.0653H16.7567V14.6449H19.1744V15.5284H16.7567V18H15.7028Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5713_31812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.f35e0f397c5b2c9226c4f341eafe12ef.svg";
export { ForwardRef as ReactComponent };